import FingerprintJS from "@fingerprintjs/fingerprintjs";
/**
 * @returns {Promise<string>} The user's unique browser ID.
 */
export const getBrowserId = async (): Promise<string> => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
}
